import { DollarSign } from "@tamagui/lucide-icons";
import { LoadingButton, Paragraph, Subheadline3, YStack } from "@medbillai/ui";
import { useRouter } from "@medbillai/navigation/router";
import { Flag } from "@medbillai/utils";
import { accountsUrl, coverageUrl } from "@medbillai/utils/urls";
import { ShadowCircleHeader } from "../../../../components/ShadowCircleHeader";
import { analyticsService } from "../../../../lib/analytics";
import { useBoolVariation } from "../../../../lib/flag";
import { filterOptionIds } from "../../utils/utils";
interface NoInsuranceBlockProps {
  selectedFilter: string;
}
interface NoInsuranceTextContent {
  title: string;
  text: string;
}
export const NoInsuranceText = (selectFilter: string): NoInsuranceTextContent => {
  switch (selectFilter) {
    case filterOptionIds.denied:
      return {
        title: "Having issues with \n denied bills?",
        text: "Connect your insurance \n and we can help."
      };
    case filterOptionIds.inNetwork:
      return {
        title: "Want to view all your in \n network bills?",
        text: "Connect your insurance \n and we can help."
      };
    case filterOptionIds.outOfNetwork:
      return {
        title: "Want to view all your out \n of network bills?",
        text: "Connect your insurance \n and we can help."
      };
    default:
      return {
        title: "Connect your insurance \n",
        text: "We can help view and manage your bills."
      };
  }
};
export const NoInsuranceBlock = ({
  selectedFilter
}: NoInsuranceBlockProps) => {
  const {
    push
  } = useRouter();
  const coverageTab = useBoolVariation(Flag.COVERAGE_TAB, false);
  const onPress = () => {
    analyticsService.trackEvent("BillsClaimsConnectInsuranceTapped", {});
    push(coverageTab ? coverageUrl() : accountsUrl());
  };
  const {
    title,
    text
  } = NoInsuranceText(selectedFilter);
  return <YStack alignItems="center" justifyContent="flex-start" gap="$2" $platform-web={{
    maxWidth: 400,
    mx: "$5"
  }} data-sentry-element="YStack" data-sentry-component="NoInsuranceBlock" data-sentry-source-file="NoInsuranceBlock.tsx">
      <ShadowCircleHeader icon={DollarSign} data-sentry-element="ShadowCircleHeader" data-sentry-source-file="NoInsuranceBlock.tsx" />
      <Subheadline3 numberOfLines={2} pt="$2" textAlign="center" data-sentry-element="Subheadline3" data-sentry-source-file="NoInsuranceBlock.tsx">
        {title}
      </Subheadline3>
      <Paragraph theme="alt1" px="$8" textAlign="center" data-sentry-element="Paragraph" data-sentry-source-file="NoInsuranceBlock.tsx">
        {text}
      </Paragraph>
      <LoadingButton onPress={onPress} testID="bills.empty-state.connect" width="$16" mt="$4" height="$4" data-sentry-element="LoadingButton" data-sentry-source-file="NoInsuranceBlock.tsx">
        Connect account
      </LoadingButton>
    </YStack>;
};